import { styled } from '@/styles/stitches';

export const SidebarNavContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  justifyContent: 'space-between',
});

export const NavSubContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '$4',

  p: {
    width: '100%',
    height: '$10',
    display: 'flex',
    alignItems: 'center',
    transition: 'background 0.2s ease',

    fontSize: '$xs',
    color: '$gray-700',
    fontWeight: '$semiBold',
    backgroundColor: 'transparent',
    paddingLeft: '$6',
    cursor: 'default',
    textTransform: 'uppercase',
  },

  button: {
    width: '100%',
    height: '$10',
    display: 'flex',
    alignItems: 'center',
    transition: 'background 0.2s ease',
    fontWeight: '$semiBold',
    fontSize: '$sm',
    color: '$gray-500',
    backgroundColor: 'transparent',
    border: 'none',
    outline: 'none',
    cursor: 'pointer',
    paddingLeft: '$6',

    '&:hover': {
      background: '$gray-100',
    },
  },
});
